import { render, staticRenderFns } from "./StockTurnoverList.vue?vue&type=template&id=58e308f5&scoped=true"
import script from "./StockTurnoverList.vue?vue&type=script&lang=js"
export * from "./StockTurnoverList.vue?vue&type=script&lang=js"
import style0 from "./StockTurnoverList.vue?vue&type=style&index=0&id=58e308f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e308f5",
  null
  
)

export default component.exports